<form [formGroup]="form" class="style-form row">
  <!-- <div class="style-input-default" data-text="Accion autorizada *" [ngClass]="{error: verificateInput('nombre_empresa')}"> -->
  <!-- <input type="text" placeholder="Accion autorizada" formControlName="accion_autorizada"> -->

  <div style="display: flex" class="col-12">
    <p class="inputRadio">¿Acción autorizada?</p>
    <mat-radio-group
      style="margin-left: 60px"
      formControlName="accion_autorizada"
      aria-label="Select an option"
    >
      <mat-radio-button value="Si">Si</mat-radio-button>
      <mat-radio-button style="margin-left: 10px" value="No"
        >No</mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div class="col-12 row" *ngIf="form.value.accion_autorizada == 'No'">
    <div class="col-12 center">
      <p>Datos del personal interno involucrado</p>
    </div>
    <div class="col-4">
      <mat-form-field class="wid" appearance="outline">
        <mat-label>Nombres y apellidos personal</mat-label>
        <input formControlName="nombre" matInput />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="wid" appearance="outline">
        <mat-label>Cargo</mat-label>
        <input formControlName="cargo" matInput />
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field class="wid" appearance="outline">
        <mat-label>NM</mat-label>
        <input formControlName="NM" matInput />
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="width100" appearance="outline">
        <mat-label>Descripción</mat-label>
        <textarea
          matInput
          placeholder="Descripción del caso: detalles de la acción no autorizada..."
          formControlName="descripcion"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
  <!-- <div style="display: flex;padding: 16px 15px;" class="check">
        <mat-form-field style="width: 100%;">
            <mat-label>Correo (Empleado sospechoso)</mat-label>
            <input
              type="text"
              formControlName="correo"
              matInput
              placeholder="Ingrese su correo"
            />
            <mat-error *ngIf="form.get('correo').hasError('required')"
              >El correo es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="form.get('correo').hasError('email')"
              >El correo es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
     </div> -->

  <!-- </div> -->
  <!-- <div class="style-input-default" data-text="Observaciones *" [ngClass]="{error: verificateInput('rif')}">
      <input type="text" placeholder="Escriba sus observacioes" formControlName="observaciones">
    </div> -->
</form>
